<template>
    <div v-loading="loading">
        <el-calendar v-if="loaded" class="notranslate big-calendar">
            <template slot="dateCell" slot-scope="{date, data}">
                <div v-if="!getBookingData(data).dayOff" style="min-height: 100px">
                    {{data.day.split("-")[2]}}
                    <span style="font-size: 50%;">{{isCurrentDay(data.day) ? ' (current-day) ' : ''}}</span>
                    <p class="time-range" v-for="timeRange in getBookingData(data)"
                       @click="onClick(timeRange)"
                       :class="getCalendarTimeRangeClass(timeRange)">
                        <label>{{timeRange.time}}</label>
                        <br/>
                        <label>{{timeRange.availableSlot ? ($t('homePage.slotLeft') + timeRange.availableSlot
                            +$t('homePage.unit')) : $t('homePage.full')}}</label>
                    </p>
                </div>
                <div v-else>
                    {{data.day.split("-")[2]}}
                    <span style="font-size: 50%;">{{isCurrentDay(data.day) ? ' (current-day) ' : ''}}</span>
                    <p class="day-off">お休み</p>
                </div>
            </template>
        </el-calendar>
        <div class="small-calendar">
            <el-date-picker v-model="selectedDate" style="width: calc(100% - 80px);"
                            @change="chooseDate"></el-date-picker>
            <button class="time-btn" @click="prevDay"><</button>
            <button class="time-btn" @click="nextDay">></button>
            <div v-if="!selectedDateTimeRange.dayOff" style="min-height: 100px">
                <p class="time-range" v-for="timeRange in selectedDateTimeRange"
                   @click="onClick(timeRange)"
                   :class="getCalendarTimeRangeClass(timeRange)">
                    <label>{{timeRange.time}}</label>
                    <br/>
                    <label>{{timeRange.availableSlot ? ($t('homePage.slotLeft') + timeRange.availableSlot
                        +$t('homePage.unit')) : $t('homePage.full')}}</label>
                </p>
                <p class="no-booking" v-if="selectedDateTimeRange.length === 0">
                    現在、予約はありません。
                </p>
            </div>
            <div v-else>
                <p class="day-off">{{$t('homePage.dayOff')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Pages from "../router/Pages";
    import BookingCalendarApi from "../api/calendar/BookingCalendarApi";
    import AlertService from "../service/alert.service";
    import FacilityApi from "../api/facility/FacilityApi";
    import moment from "moment";

    export default {
        name: "BookingCalendar",
        data() {
            return {
                config: [],
                status: [],
                dayOff: [],
                loaded: false,
                facilityCode: "",
                loading: false,
                selectedDate: new Date(moment(new Date()).format("YYYY/MM/DD")),
                selectedDateTimeRange: [],
                preBookingHourMap: {
                    "THREE_HOUR_BEFORE_START": 3,
                    "SIX_HOUR_BEFORE_START": 6,
                    "TWELVE_HOUR_BEFORE_START": 12,
                    "TWENTY_FOUR_HOUR_BEFORE_START": 24
                }
            }
        },
        methods: {
            getCalendarTimeRangeClass(timeRange) {
                if (timeRange.availableSlot == 0)
                    return 'full';
                if (timeRange.expired)
                    return "expired-time-range";
                return "";
            },
            nextDay() {
                this.selectedDate = moment(this.selectedDate).add(1, 'day');
                this.chooseDate();
            },
            prevDay() {
                this.selectedDate = moment(this.selectedDate).add(-1, 'day');
                this.chooseDate();
            },
            isCurrentDay(day) {
                if (moment(new Date()).format("YYYY-MM-DD") === day) console.log("is current day ", day, moment(new Date()).format("YYYY-MM-DD"));
                return moment(new Date()).format("YYYY-MM-DD") === day;
            },
            onClick(timeRange) {
                if (!timeRange.availableSlot || timeRange.expired) return;
                this.$emit("chooseTimeRange", timeRange)
            },
            chooseDate() {
                let date = moment(this.selectedDate).format("YYYY/MM/DD");
                this.selectedDateTimeRange = this.getBooking(date);
            },
            getBookingData(data) {
                const date = data.day.split("-").join("/");
                return this.getBooking(date);
            },
            getBooking(date) {
                function dateDiff(d1, d2) {
                    return Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24))
                }

                let currentTime = new Date();
                let diff = dateDiff(currentTime, new Date(date));

                //yesterday
                if (diff < 0) return [];

                //Day off
                if (this.dayOff.includes(date)) return {dayOff: true};

                for (let i = 0; i < this.config.length; i++) {
                    const config = this.config[i];
                    if ((config.startDate <= date && (!config.endDate || (config.endDate && config.endDate >= date)))) {
                        //console.log("config", i);
                        if (diff > config.canBookBeforeNumberOfDay) {
                            return [];
                        }

                        let preBookingHour = this.preBookingHourMap[config.bookingStrategy];

                        let availableTimeRange = config.bookingTimeRanges;

                        return availableTimeRange.map(timeRange => {
                            /**Calculate max slot of time range at this date.*/
                            let timeRangeCustoms = timeRange.bookingTimeRangeCustoms;
                            let maxSlot = timeRange.maxSlot;
                            for (let i = 0; i < timeRangeCustoms.length; i++) {
                                let customDate = timeRangeCustoms[i].date.split("-").join("/");
                                if (customDate === date) {
                                    maxSlot = timeRangeCustoms[i].maxSlot;
                                    break;
                                }
                            }

                            let bookedSlot = this.status[timeRange.code + "_" + date];
                            if (!bookedSlot) bookedSlot = 0;
                            timeRange.start = (timeRange.startHour < 10 ? "0" : "") + timeRange.startHour + ":" + (timeRange.startMinute < 10 ? "0" : "") + timeRange.startMinute;
                            timeRange.end = (timeRange.endHour < 10 ? "0" : "") + timeRange.endHour + ":" + (timeRange.endMinute < 10 ? "0" : "") + timeRange.endMinute;
                            let expired = false;
                            if (diff === 0) {
                                if (config.bookingStrategy === "BEFORE_MIDNIGHT" || config.bookingStrategy === "FIXED_TIME_ON_DAY_BEFORE") {
                                    expired = true;
                                } else if (timeRange.startHour < currentTime.getHours() + preBookingHour) {
                                    expired = true;
                                } else if (timeRange.startHour == currentTime.getHours() + preBookingHour) {
                                    expired = currentTime.getMinutes() > timeRange.startMinute;
                                }
                            }

                            if (diff === 1) {
                                if (config.bookingStrategy === "FIXED_TIME_ON_DAY_BEFORE") {
                                    const currentTimeStr = (currentTime.getHours() < 10 ? "0" : "") + currentTime.getHours() +
                                        ":" + (currentTime.getMinutes() < 10 ? "0" : "") + currentTime.getMinutes();
                                    console.log(currentTimeStr, config.fixedTime);
                                    if (currentTimeStr > config.fixedTime) {
                                        expired = true;
                                    }
                                } else if (config.bookingStrategy !== "BEFORE_MIDNIGHT") {
                                    let yesterdayDeadline = 24 + timeRange.startHour - preBookingHour;
                                    if (yesterdayDeadline < currentTime.getHours()) {
                                        expired = true;
                                    }
                                    if (yesterdayDeadline === currentTime.getHours() && timeRange.startMinute < currentTime.getMinutes()) {
                                        expired = true;
                                    }
                                }
                            }

                            return {
                                code: timeRange.code,
                                date: date,
                                time: timeRange.start + ' - ' + timeRange.end,
                                availableSlot: maxSlot - bookedSlot,
                                maxSlot: maxSlot,
                                bookedSlot: bookedSlot,
                                expired: expired
                            }
                        });
                    }
                }
                return [];
            },
            reload(code) {
                this.facilityCode = code;
                this.loading = true;

                BookingCalendarApi.get(this.facilityCode)
                    .then(response => {
                        console.log("Response: ");
                        console.log(response);
                        response.configs.map(config => {
                            config.startDate = config.startDate.split(" ")[0];
                            if (config.endDate)
                                config.endDate = config.endDate.split(" ")[0];
                            else config.endDate = null;
                        });
                        [this.config, this.status, this.dayOff] = [response.configs, response.status, response.dayOff]
                        this.chooseDate();
                        this.loaded = true;
                        this.loading = false;

                    })
                    .catch(error => {
                        AlertService.error(error);
                    });
            }
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 770px) {
        .big-calendar {
            display: none !important;
        }

        .small-calendar {
            display: block !important;
        }
    }

    .big-calendar {
        display: block;
    }

    .small-calendar {
        display: none;
    }

    .is-selected {
        color: #1989FA;
    }

    .day-off {
        border: 1px solid red;
        color: red;
        text-align: center;
        font-size: 80%;
    }

    .time-range {
        background-color: #1c6ca1;
        color: #ffffff;
        text-align: center;
        font-size: 70%;
        cursor: pointer;
        padding: 5px;
    }

    .time-range:hover {
        background-color: #2087c3;
    }

    .time-range:active {
        background-color: #2395d7;
    }

    .time-range.full {
        background-color: #999999;
    }

    .time-range.expired-time-range {
        background-color: #D58400;
    }

    .time-range > * {
        cursor: pointer;
    }

    /deep/ .el-calendar-table .el-calendar-day {
        height: auto !important;
    }

    .small-calendar {
        .day-off, .no-booking {
            height: 80px;
            font-size: 25px;
            padding-top: 50px;
        }

        .no-booking {
            border: 1px solid #7a7a7a;
            color: #7a7a7a;
            text-align: center;
        }

        .time-btn {
            margin-left: 5px;
            width: 35px;
            height: 40px;
            background: #c2c2c2;
            border: none;
            border-radius: 5px;
            font-weight: bold;

            &:focus, &:active {
                background: #afafaf;
            }
        }
    }
</style>
